// Removes the selected elements from the dom
// Example: <a data-remove='.some-element'>Click Me</a>

$(document).on('click', 'a[data-remove]', function (e) {
  e.preventDefault();
  var selector = $(this).data('remove');
  $(selector).fadeOut(300, function () { $(this).remove(); });
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dom/remove.js